import { message, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { decryptData, encryptData } from "../../../../actions/crypto";
import { getData } from "../../../../actions/apiCall";
import { postData, putData } from "../../../../actions/developer";
import { useParams } from "react-router-dom";

const FullscreenValidator = ({ children }) => {
    const { id } = useParams();
    const [config, setConfig] = useState({
        fullScreen: 0
    })

    const dispatch = useDispatch();

    const getStatus = () => {
        return location.href.includes('/exam')
    }

    useEffect(() => {
        getConfig()
    }, []);

    const getConfig = async () => {
        try {
            const resData = await dispatch(getData(`/accel-test/fetch/cheating/config/${id}`));
            if (resData.code == 200) {
                const config = decryptData(resData.data);
                if (config) {
                    const {
                        fullScreen
                    } = config;
                    setConfig({
                        fullScreen
                    });
                }
            } else {
                message.error("Failed to fetch configuration.");
            }
        } catch (error) {
            message.error("Failed to fetch configuration.");
        }
    };


    useEffect(() => {
        if (getStatus()) {
            if (config.fullScreen >= 3) {
                handleSubmitTest('Full screen exit detected 3 times');
            }
        }
    }, [config, getStatus()]);

    const handleSubmitTest = async (msg) => {
        try {
            const log = msg;
            const resData = await dispatch(postData(`/accel-test/faild/test/submit/${id}`, { data: encryptData({ log }) }));
            if (resData.code == 200) {
                message.success("Test submitted successfully.");
            } else {
                message.error("Failed to submit the test.");
            }
        } catch (error) {
            console.error("Error submitting test:", error);
            message.error("Failed to submit the test.");
        } finally {
            location.href = `/instructions/${id}`;
        }
    }

    const getMessage = (type) => {
        const message = {
            fullScreen: 'Full screen exit detected. This may be considered cheating.',
        }
        return message[type];
    }

    const handleConfig = (type: string) => {
        if (getStatus()) {
            message.warning(getMessage(type));
            const data = encryptData({ field: type });
            const resData = dispatch(putData(`/accel-test/update/cheating/config/${id}`, { data }), false);
            if (resData) {
                getConfig()
            }
        }
    }

    useEffect(() => {
        const fullscreenChangeHandler = () => {
            const isNowFullscreen = !!document.fullscreenElement;

            if (!isNowFullscreen) {
                handleMinimize();
            }
        };

        document.addEventListener("fullscreenchange", fullscreenChangeHandler);
        return () => {
            document.removeEventListener("fullscreenchange", fullscreenChangeHandler);
        };
    }, []);

    const handleMinimize = () => {
        showExitWarning();
    };

    const showExitWarning = () => {
        Modal.confirm({
            title: "Warning",
            content: "Exiting fullscreen mode will interrupt your test. You must stay in fullscreen mode.",
            onCancel: () => {
                requestFullScreen();
            },
            okText: "Exit",
            okButtonProps: { danger: true, hidden: true },
            cancelText: "Stay in Fullscreen"
        });
    };

    const requestFullScreen = () => {
        const element: any = document.documentElement;
        if (element.requestFullscreen) {
            element.requestFullscreen().catch((error) => console.error("Failed to enter fullscreen:", error));
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
        handleConfig('fullScreen');
    };


    useEffect(() => {
        if (!document.fullscreenElement) {
            showExitWarning();
        }
    }, []);

    return children
}

export default FullscreenValidator;